import {
	CancellableEvent,
	PageWrapper,
	SecondaryNavProps,
} from '@innovyze/stylovyze';
import React, { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { resetSystemConnectionStore } from '@Actions';
import GeneralSettingsSecondary from '@Components/GeneralSettings/GeneralSettingsSecondary';
import { useNavigateTo } from '@Hooks';
import { useGlobalization } from '@Translations';
import IntegrationsViewRouter from '../../features/IntegrationsTab/routes/IntegrationsViewRouter';
import useGetIntegrationsIndex from '../../features/IntegrationsTab/useGetIntegrationsIndex.hooks';
import { useTabs } from './tabs';
import isGeneralSettingsTab from '@Utils/isGeneralSettingsTab';

// Navbar should remembers where it exited
const navPageIndex = 0;

export enum AdminSecondaryNavPages {
	System_connections,
	Sensor_configuration,
	Entitlements,
	Hidden_sensor_configuration_details,
}

const Admin = ({ page }: { page?: number }) => {
	const { t } = useGlobalization();
	const dispatch = useDispatch();
	const location = useLocation<{ pageIndex: number }>();
	const history = useHistory();
	useNavigateTo();

	const isGeneralSettings = React.useMemo(
		() => isGeneralSettingsTab(location.pathname),
		[location.pathname],
	);

	const tabs = useTabs({ t });
	const integrationIndex = useGetIntegrationsIndex(/integration/);

	const itemIndex = useMemo(
		() => location.state?.pageIndex || page || navPageIndex,
		[location.state, page],
	);

	const beforeItemIndexChanged = (
		event: CancellableEvent,
	): CancellableEvent => {
		event.cancelled = true;
		const to = tabs[event.toIndex]?.to;
		if (to) history.push(to);
		return event;
	};

	const secondaryNavProps: SecondaryNavProps = {
		items: tabs,
		beforeItemIndexChanged,
		itemIndex,
	};

	useEffect(() => {
		dispatch(resetSystemConnectionStore());
	}, []);

	const secondaryPage = isGeneralSettings && <GeneralSettingsSecondary />;

	return (
		<PageWrapper
			title={t('Admin')}
			secondary={secondaryPage}
			applyPadding={true}
			secondaryNav={secondaryNavProps}
			isLoading={false}>
			{integrationIndex === itemIndex && <IntegrationsViewRouter />}
		</PageWrapper>
	);
};

export default Admin;
